import type {
    AidPreferenceClessEntityObject,
    AidPreferenceClessQueryParams,
} from "src/app/features/EmvKernelProfile/subFeatures/AidPreferenceCless/services/server/AidPreferenceClessQueryTypes";
import { getAssignedDataGroup } from "../../../../../../../core/router/auth";
import { ResourceName, ResourceVariant } from "../../../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../../../core/service/baseApi";
import type { Dto } from "../../../../../../../core/types/be/Dto";
import type { AidPreferenceClessEntity } from "../../types/AidPreferenceClessEntity";
import { AidPreferenceClessDtoToEntity } from "../mappers/AidPreferenceClessDtoToEntity";
import { AidPreferenceClessEntityToDto } from "../mappers/AidPreferenceClessEntityToDto";

const AidPreferenceClessApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        AidPreferenceClessLoad: builder.query<AidPreferenceClessEntity, AidPreferenceClessQueryParams>({
            providesTags: [ResourceName.AID_PREFERENCES],
            query: (aidPreferenceClessQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${aidPreferenceClessQueryParams.emvKernelProfileId}/${ResourceName.AID_PREFERENCES_CLESS}/${aidPreferenceClessQueryParams.id}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return AidPreferenceClessDtoToEntity(response);
            },
        }),
        AidPreferenceClessSave: builder.mutation<AidPreferenceClessEntity, AidPreferenceClessEntityObject>({
            query: (aidPreferenceClessEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${aidPreferenceClessEntityObject.aidPreferenceClessQuery.emvKernelProfileId}/${ResourceName.AID_PREFERENCES_CLESS}`;
                const method = "POST";

                const body = AidPreferenceClessEntityToDto(aidPreferenceClessEntityObject.aidPreferenceClessFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.AID_PREFERENCES_CLESS],
        }),
        AidPreferenceClessUpdate: builder.mutation<AidPreferenceClessEntity, AidPreferenceClessEntityObject>({
            query: (aidPreferenceClessEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${aidPreferenceClessEntityObject.aidPreferenceClessQuery.emvKernelProfileId}/${ResourceName.AID_PREFERENCES_CLESS}/${aidPreferenceClessEntityObject.aidPreferenceClessQuery.id}`;
                const method = "PUT";

                const body = AidPreferenceClessEntityToDto(aidPreferenceClessEntityObject.aidPreferenceClessFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.AID_PREFERENCES_CLESS],
        }),
        AidPreferenceClessDelete: builder.mutation<AidPreferenceClessEntity, AidPreferenceClessQueryParams>({
            query: (aidPreferenceClessQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${aidPreferenceClessQueryParams.emvKernelProfileId}/${ResourceName.AID_PREFERENCES_CLESS}/${aidPreferenceClessQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.AID_PREFERENCES_CLESS],
        }),
    }),
});

export const {
    useLazyAidPreferenceClessLoadQuery,
    useAidPreferenceClessSaveMutation,
    useAidPreferenceClessUpdateMutation,
    useAidPreferenceClessDeleteMutation,
} = AidPreferenceClessApi;
